import { useSocialAuth } from 'api';
import { useGoogleOneTap } from 'oauth';
import { DEFAULT_GOOGLE_LOGIN_ERROR_MESSAGE } from 'ui/constants';
import { useAuth } from 'ui/context/AuthContext';
import { SocialAuthSuccessResponse } from 'ui/types';
import { ensureAuthResponse, getGoogleAuthErrorMessage } from 'ui/utils';

export interface UseGoogleOneTapAuthConfig {
  onError?: (message: string) => void;
  onSuccess?: (response: SocialAuthSuccessResponse) => void;
}

export default function useGoogleOneTapAuth(
  config?: UseGoogleOneTapAuthConfig,
) {
  const { onError: onErrorProp, onSuccess: onSuccessProp } = config ?? {};

  const { promotionKey, referralKey, traceId } = useAuth();

  const { mutate: socialAuth } = useSocialAuth();

  useGoogleOneTap({
    onSuccess(token) {
      socialAuth(
        {
          promotionKey,
          referralKey,
          traceId,
          authenticationServiceToken: token,
          identityProvider: 'google',
        },
        {
          onSuccess(data) {
            try {
              onSuccessProp?.(ensureAuthResponse(data));
            } catch {
              onErrorProp?.(DEFAULT_GOOGLE_LOGIN_ERROR_MESSAGE);
            }
          },
          onError(err) {
            onErrorProp?.(getGoogleAuthErrorMessage(err));
          },
        },
      );
    },
  });
}
